const initialState = {
  data: [],
  loading: false,
  error: false,
};

export function peakHoursAnalytics(state = initialState, action) {
  switch (action.type) {
    case "PEAK_HOURS_ANALYTICS_FETCH_DATA_SUCCESS":
      return { ...state, data: action.data, error: false };
    default:
      return state;
  }
}
